/**
 * Empty state for activity search results (TRAV23 activities-front merge).
 *
 * Renders ghost cards behind a message so the results area keeps its shape when a
 * search returns nothing, rather than collapsing to a bare line of text.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import './style.scss';

interface IProps {
  location?: string;
}

export const ActivityEmptyState: React.FC<IProps> = ({ location }) => {
  return (
    <div className="activity-empty-state">
      <div className="activity-empty-state__ghost-grid">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="activity-empty-state__ghost-card">
            <div className="activity-empty-state__ghost-img" />
            <div className="activity-empty-state__ghost-body">
              <div className="activity-empty-state__ghost-line" />
              <div className="activity-empty-state__ghost-line activity-empty-state__ghost-line--short" />
              <div className="activity-empty-state__ghost-line activity-empty-state__ghost-line--xshort" />
            </div>
          </div>
        ))}
      </div>

      <div className="activity-empty-state__overlay">
        <div className="activity-empty-state__icon-circle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
          </svg>
        </div>

        <p className="activity-empty-state__title">
          {location
            ? <FormattedMessage id="no.activities.found.in" values={{ location }} />
            : <FormattedMessage id="no.activities.found" />}
        </p>

        <p className="activity-empty-state__subtitle">
          <FormattedMessage id="no.activities.found.subtitle" />
        </p>
      </div>
    </div>
  );
};
